module.exports = __webpack_public_path__ + "static/media/weekend_cropped.fcc47758.webp";